import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import GoldDivider from '../components/GoldDivider';
import InfoCard from '../components/InfoCard';

export default function Home() {
  const { t } = useLanguage();

  return (
    <div>
      {/* HERO */}
      <section style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: '6rem 2rem 4rem',
        background: 'radial-gradient(ellipse at 50% 40%, var(--navy-mid) 0%, var(--navy) 70%)',
        zIndex: 1,
      }}>
        <div style={{
          textAlign: 'center',
          maxWidth: '720px',
          position: 'relative',
          zIndex: 1,
          animation: 'fadeUp 1.2s ease both',
        }}>
          {/* Dual photo */}
          <div style={{ position: 'relative', width: '220px', height: '220px', margin: '0 auto 2rem' }}>
            <div style={{ width: '180px', height: '180px', borderRadius: '50%', border: '4px solid var(--gold)', overflow: 'hidden', position: 'absolute', top: '20px', left: '50%', transform: 'translateX(-50%)', boxShadow: '0 8px 32px rgba(0,0,0,0.4)', background: 'var(--navy)' }}>
              <img src="/papa_bb.jpg" alt="Michel bébé" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div style={{ width: '90px', height: '90px', borderRadius: '50%', border: '3px solid var(--gold)', overflow: 'hidden', position: 'absolute', bottom: '0', right: '0', boxShadow: '0 4px 16px rgba(0,0,0,0.5)', background: 'var(--navy)', zIndex: 2 }}>
              <img src="/papa_adult.png" alt="Michel aujourd'hui" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} />
            </div>
            <div style={{ position: 'absolute', top: '0', left: '0', width: '44px', height: '44px', borderRadius: '50%', background: 'var(--gold)', color: 'var(--navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Cinzel', serif", fontWeight: 700, fontSize: '1rem', boxShadow: '0 2px 8px rgba(0,0,0,0.3)', zIndex: 3 }}>50</div>
          </div>

          {/* Eyebrow */}
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic', fontSize: '1.2rem', color: 'var(--gold-light)', letterSpacing: '0.1em', marginBottom: '0.5rem' }}>
            {t('home.hero_eyebrow')}
          </p>

          {/* Big "50" */}
          <div style={{
            fontFamily: "'Cinzel', serif",
            fontSize: 'clamp(5rem, 16vw, 10rem)',
            fontWeight: 700,
            lineHeight: 0.9,
            background: 'linear-gradient(135deg, var(--gold) 0%, var(--gold-light) 50%, var(--gold) 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            filter: 'drop-shadow(0 4px 20px rgba(201,168,76,0.4))',
            marginBottom: '0.25rem',
          }}>
            50
          </div>

          {/* Title */}
          <div style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(1.8rem, 5vw, 3rem)',
            fontWeight: 300,
            letterSpacing: '0.25em',
            textTransform: 'uppercase',
            color: 'var(--cream)',
            marginBottom: '1rem',
          }}>
            {t('home.hero_title_word')}
          </div>

          {/* Motto */}
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic', fontSize: '1.5rem', color: 'var(--gold)', marginBottom: '1.5rem' }}>
            ✦ {t('home.hero_motto')} ✦
          </div>

          <GoldDivider />

          {/* Date */}
          <p style={{ fontFamily: "'Cinzel', serif", fontSize: '1rem', letterSpacing: '0.2em', color: 'var(--gold-pale)', marginBottom: '2rem' }}>
            {t('home.hero_date')}
          </p>

          {/* Schedule cards — nur Sektempfang mit Uhrzeit, Gala-Abend ohne */}
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '2rem' }}>
            <div style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '4px', padding: '1.2rem 1.8rem', textAlign: 'center', minWidth: '200px' }}>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: '0.8rem', color: 'var(--gold)', letterSpacing: '0.15em', marginBottom: '0.3rem' }}>17:00</div>
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.1rem', color: 'var(--cream)' }}>{t('home.info_cocktail_title')}</div>
            </div>
            <div style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '4px', padding: '1.2rem 1.8rem', textAlign: 'center', minWidth: '200px' }}>
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.1rem', color: 'var(--cream)', paddingTop: '0.2rem' }}>{t('home.info_dinner_title')}</div>
              <div style={{ fontSize: '0.72rem', color: '#fc8181', fontStyle: 'italic', marginTop: '0.3rem' }}>{t('home.info_dinner_note')}</div>
            </div>
          </div>

          {/* Info block */}
          <div style={{ fontSize: '0.85rem', color: 'rgba(245,233,198,0.7)', letterSpacing: '0.05em' }}>
            <div style={{ color: 'var(--gold)', fontSize: '1rem', letterSpacing: '0.3rem', marginBottom: '0.75rem', opacity: 0.7 }}>★ ★ ★</div>
            <div style={{
              display: 'inline-block', padding: '0.5rem 1.4rem',
              border: '1px solid var(--gold)',
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: '0.9rem',
              fontStyle: 'italic',
              color: 'var(--gold-pale)',
              marginBottom: '1rem',
              maxWidth: '480px',
              lineHeight: 1.5,
            }}>
              {t('home.info_dresscode_title')} · {t('home.info_dresscode_value')}
            </div>
            <p style={{ marginBottom: '0.5rem', fontStyle: 'italic', color: 'rgba(245,233,198,0.55)' }}>{t('home.hero_children_note')}</p>
            <p>{t('home.hero_venue')}</p>
            <p style={{ marginTop: '0.3rem' }}>{t('home.hero_deadline')}</p>
          </div>

          <div style={{ marginTop: '2.5rem' }}>
            <Link to="/rsvp" className="btn-primary">{t('home.cta_rsvp')} ✦</Link>
          </div>
        </div>
      </section>

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
